import { PostPlatformCategoryFilter, Report } from '@/type';
import { allStatuses as allPostStatuses } from '@/social/post/post';
import { generate } from '@/report/report';
import { types as reportTypes } from '@/report';

export function createAlbum(
  clientId: number, name: string, statuses: number[],
  socialSiteIds: number[], mediaTypes: string[], startDate?: string|null, endDate?: string|null,
  categoryIds?: PostPlatformCategoryFilter,
): Promise<Report> {
  return generate(
    clientId,
    reportTypes.ALBUM,
    name,
    allPostStatuses(),
    true,
    socialSiteIds,
    undefined,
    undefined,
    mediaTypes,
    [],
    startDate,
    endDate,
    categoryIds,
  );
}
